import type { ReshuffleZone, SweptCommandDestination } from './session';

/** Cards in the opening hand, and in every hand dealt after a mulligan or new game. */
export const OPENING_HAND_SIZE = 7;

/** Free mulligans for the deck types in FREE_MULLIGAN_DECK_TYPES. */
export const COMMANDER_FREE_MULLIGANS = 1;

/** Extra cost added per earlier cast from the command zone (the commander tax). Display only. */
export const COMMANDER_TAX_PER_CAST = 2;

/** Zones a reshuffle draws from when the library runs out. */
export const DEFAULT_RESHUFFLE_FROM: readonly ReshuffleZone[] = ['graveyard', 'exile'];

/** Where a swept command-zone card goes on a reshuffle (O3). */
export const DEFAULT_SWEPT_COMMAND_TO: SweptCommandDestination = 'command';

/** UI only: how many cards the peek control shows. */
export const DEFAULT_PEEK_COUNT = 3;

/** UI only: how many undo steps the playtest board keeps. */
export const UNDO_DEPTH = 50;

/** UI only, not part of the engine contract: clockwise rotation, in degrees, of a tapped battlefield card. */
export const TAPPED_ROTATION_DEG = 90;

/** UI only, not part of the engine contract: lines of a card name shown on a card face that has no image. */
export const CARD_NAME_MAX_LINES = 4;

const FREE_MULLIGAN_DECK_TYPES: readonly string[] = [
  'COMMANDER',
  'BRAWL',
  'STANDARD_BRAWL',
  'OATHBREAKER',
];

/** Free mulligans for a deck type; 0 for every other type, including null. */
export function freeMulligansFor(deckType: string | null | undefined): number {
  return typeof deckType === 'string' && FREE_MULLIGAN_DECK_TYPES.includes(deckType)
    ? COMMANDER_FREE_MULLIGANS
    : 0;
}
